import React,{Component} from 'react';
import {PostData} from '../../../service/postData';
import {sendNotification} from '../../../_notificationSettings/notificationPanel';
import { MDBDataTableV5 } from 'mdbreact';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Modal from 'react-modal';

global.BACK_URL = 'Company';

let columns = [
    {
        label: '#',
        field: 'srNo',
        width: 20,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': '#',
        },
    },
    {
        label: 'Name',
        field: 'name',
        width: 150
    },
    {
        label: 'Status',
        field: 'status',
        width: 100,
    },
    {
        label: 'Action',
        field: 'action',
        width: 100,
    }
];

let _loader = 'glb-ldr-prt active';

export default class gstTypeListPanel extends Component{
    constructor(props){
        super(props);

        this.state = {
            buttonTitle:'Add New',
            isLoaded : true,
            gstName : null,
            countryCode : this.props.countryCode,
            gstArray : [],
            gstId : 0,
            modalIsOpen_CTT : false,
            errors: {
                gstName : ''
            }
        }
    }

    async componentDidMount ()
    {
        this.getGstTypeListData();
    }

    getGstTypeListData(){
        let _gstArray = [];

        let _url_GetData = global.gstTypeList+'?countryCode='+this.props.countryCode;
        PostData(_url_GetData,'','GET').then(result => {
            let responseJson = result;
            if(responseJson.success == false)
            {  
                this.setState({isLoaded:true,gstArray:[]});                
            }
            else
            {
                if (responseJson.response) {
                    _gstArray = responseJson.response;
                }
                this.setState({gstArray:_gstArray,isLoaded:true});               
            }             
        })
        .catch(error => this.setState({ error, isLoaded: false }));
    }

    clickToStatus(value,_status)
    {
        confirmAlert({
            title: 'Confirm to manage status',
            message: 'Are you sure you want to change the status?',
            buttons: [
            { 
                label: 'Yes',
                className: 'btn btn-danger',
                onClick: () => {
                    const requestData = JSON.stringify({
                        taxTypeId: value,
                        status:_status
                    });
                    PostData(global.adminTaxTypeStatus, requestData,'POST').then((result) => {
                        let responseJson = result;                
                        if(responseJson.success == false)
                        {
                            sendNotification("Error Message 😓",responseJson.message,"danger");
                            return;
                        }
                        else
                        {
                            sendNotification("Welcome Back  👍",responseJson.message,"success");
                            this.getGstTypeListData();
                            return;
                        }
                    });
                }
            },
            {
                label: 'No',
                className: 'btn btn-dark',
            }
            ]
        });
    }
    gatTypeListing()
    {   
        if(this.state.isLoaded == true)
        {
            let _gstDetails = this.state.gstArray;
            let dataList = [];
            let rows = [];

            if(_gstDetails.length > 0)
            {                          
                _gstDetails.map((compDatas, i) =>
                {
                    const row = compDatas;
                    let _status = 1;
                    let status = <span className={`badge badge-danger`}>Disabled</span>;
                    if (row.status == '1' || row.status == 1) {
                        _status = 0;
                        status = <span className={`badge badge-success`}>Enabled</span>;
                    }
                    rows.push({
                        name: row.name,
                        ratio: row.ratio,
                        srNo: row.srNo,
                        status: (status),
                        action:(
                            <div className="btn-group" role="group">
                                <button type="button" className="btn btn-secondary dropdown-toggle" id="btnGroupVerticalDrop3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="si si-list"></i>
                                </button>
                                <div className="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                                    <a className="dropdown-item" onClick={this.openModalHandlerTax.bind(this,'modalAdjustTaxType',row.id)}>
                                        <i className="si si-pencil mr-5 text-info"></i>Edit Details
                                    </a>
                                    
                                    <a className="dropdown-item" href="javascript:void(0)" data-id={row.id} onClick={this.clickToStatus.bind(this,row.id,_status)}>
                                        <i className="fa fa-exclamation-triangle mr-5 text-primary"></i>Manage Status
                                    </a>
                                </div>
                            </div>
                        )
                    });
                })
            }

            if (rows) {
                dataList = {
                    columns: columns,
                    rows: rows
                };
            }
            return dataList;
        }
    }

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let errors = this.state.errors;
        this.setState({isDisabled:false});
        switch (name) {
            case 'gstName': 
            errors.gstName = 
                value.length < 3 ? '*GST Type Name must be 3 characters long!' : '';
                this.setState({gstName:value}); 
            break;
            default:
            break;
        }
    }

    clickToAddGst = (event) => {
        event.preventDefault();
        let errors = this.state.errors;
        let _isError = false;
        if(this.state.gstName == null)
        {
            _isError = true;
            errors['gstName'] = "*Please Enter GST Type Name";
            this.setState({errors: errors});
        }

        if(_isError == false){
            if(this.state.gstId > 0){
                this.editGstMethodCall();
            }
            else{
                this.addGstMethodCall();
            }
        }
    }

    editGstMethodCall()
    {
        const requestData = JSON.stringify({
            gst_name: this.state.gstName,
            countryCode:this.props.countryCode,
            gstId: this.state.gstId
        });
        PostData(global.adminEditGstType, requestData,'POST').then((result) => {
            if(result.success == true)
            {
                sendNotification("Success Message 👍",result.message,"success");
                this.getGstTypeListData();
                this.closeModalHandlerTax('modalAdjustTaxType');
            }
            else
            {
                sendNotification("Error Message 😓",result.message,"danger");
                let errors = this.state.errors;
                errors['gstName'] = result.message;//'Please enter valid phone no.';
                this.setState({
                    errors:errors
                })
                return;
            }
        });
    }

    addGstMethodCall(){
        const requestData = JSON.stringify({
            gst_name: this.state.gstName,
            countryCode:this.props.countryCode
        });

        PostData(global.adminAddGstType, requestData,'POST').then((result) => {
            if(result.success == true)
            {
                sendNotification("Success Message 👍",result.message,"success");
                this.getGstTypeListData();
                this.closeModalHandlerTax('modalAdjustTaxType');
            }
            else
            {
                sendNotification("Error Message 😓",result.message,"danger");
                let errors = this.state.errors;
                errors['gstName'] = result.message;//'Please enter valid phone no.';
                this.setState({
                    errors:errors
                })
                return;
            }
        });
    }

    getEditTaxTypeData(gstId){
        if(gstId > 0){
            let _gstArray = [];
            let _url_GetData = global.gstTypeDetails+'?gstId='+gstId;
            PostData(_url_GetData,'','GET').then(result => {
                let responseJson = result;
                if(responseJson.success == false)
                {  
                    this.setState({isLoaded:true});                
                }
                else
                {
                    if (responseJson.response) {
                        _gstArray = responseJson.response[0];
                        this.setState({buttonTitle:'Edit',gstName:_gstArray.gst_type,gstId:_gstArray.id,isLoaded:true});
                    }
                }             
            })
            .catch(error => this.setState({ error, isLoaded: false }));
        }
    }

    /*For Modal open close*/
    openModalHandlerTax(popId,taxTypeId)
    {
        
        if(popId == 'modalAdjustTaxType'){
            this.setState({modalIsOpen_CTT: true});
            if(taxTypeId > 0){
                this.getEditTaxTypeData(taxTypeId);
            }
            else{                
                this.state.gstId = 0;
                this.setState({gstName:'',buttonTitle:'Add'});
            }
        }
    }
    closeModalHandlerTax = (popId) => {
        if(popId == 'modalAdjustTaxType'){
            this.setState({modalIsOpen_CTT: false});
        }
    }
    /*End Modal open close*/

    render(){
        if(this.state.isLoaded == true){
            _loader = 'glb-ldr-prt';
        }

        if(this.state.countryCode!=this.props.countryCode){
            this.setState({countryCode:this.props.countryCode});
            this.getGstTypeListData();
        }

        const {errors} = this.state;
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        return(
            <div>
                <h3 className="block-title">Manage {this.props.taxName} Type List
                    <button type="button" className="btn btn-sm btn-secondary mr-5 mb-5 pull-right" onClick={this.openModalHandlerTax.bind(this,'modalAdjustTaxType')}>
                        <i className="si si-equalizer mr-5"></i>Add New {this.props.taxName} Type
                    </button>
                </h3>

                <MDBDataTableV5 
                hover
                entriesOptions={[25, 50, 100]}
                entries={25}
                pagesAmount={4}
                span
                pagingTop
                searchTop
                searchBottom={false}
                barReverse
                data={this.gatTypeListing()} />
            
                {/* Modal Edit Party Details Begins */}
                <Modal isOpen={this.state.modalIsOpen_CTT} ariaHideApp={false} size="sm" aria-labelledby="modal-popout" onRequestClose={this.closeModalHandlerTax} id="modalAdjustTaxType">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="block block-themed block-transparent mb-0">
                                <div className="block-header bg-primary-dark">
                                    <h3 className="block-title">Add / Edit {this.props.taxName} Type</h3>
                                    <div className="block-options">
                                        <button type="button" className="btn-block-option" onClick={this.closeModalHandlerTax.bind(this,'modalAdjustTaxType')}>
                                            <i className="si si-close"></i>
                                        </button>
                                    </div>
                                </div>
                                <div className="block-content">
                                    <div className="block-content">
                                    <form method="post" id="form-login" className="webForm px-30">
                                        <div className="form-group row">
                                            <div className="col-6">
                                                <div className="form-material open">
                                                    <input type="text" required="required" className="form-control" id="gstName" name="gstName" value={this.state.gstName} placeholder={this.props.taxName+" Type Name Here"} onChange={this.handleChange}/>
                                                    <label htmlFor="login-username">{this.props.taxName} Type Name <span className="text-danger">*</span></label>
                                                    <span className="iris_error_txt">{errors.gstName.length > 0 && <span className='error'>{errors.gstName}</span>}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <button type="submit" disabled={isDisabled} className="btn btn-alt-primary" onClick={this.clickToAddGst}>
                                                    <i className="fa fa-check mr-5"></i> {this.state.buttonTitle} {this.props.taxName} Type
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                    <br/>
                                    
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-alt-secondary" onClick={this.closeModalHandlerTax.bind(this,'modalAdjustTaxType')}>Close</button>
                                
                            </div>
                        </div>
                    </div>
                </Modal>
                {/* Modal End Edit Party Details*/}
            </div>
        )    
    }
}